import React from "react";

export function IconArrow() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5 12h14" />
      <path d="M13 6l6 6-6 6" />
    </svg>
  );
}

export function IconHeartOutline() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12.1 20.3C8 17.2 4.5 14.1 4.5 10.4c0-2.4 1.9-4.3 4.3-4.3 1.4 0 2.7.7 3.5 1.8.8-1.1 2.1-1.8 3.5-1.8 2.4 0 4.3 1.9 4.3 4.3 0 3.7-3.5 6.8-7.6 9.9z" />
    </svg>
  );
}

export function IconBagSmall() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M7 8h13l-1.4 8.2a1.5 1.5 0 01-1.5 1.3H9.2a1.5 1.5 0 01-1.5-1.2L6.2 6.5H4" />
      <circle cx="10" cy="20" r="1.2" />
      <circle cx="17" cy="20" r="1.2" />
    </svg>
  );
}

export function IconFamily() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="9" cy="7" r="2.2" />
      <circle cx="15" cy="7.5" r="1.8" />
      <path d="M4.5 18c.4-3 2.4-4.5 4.5-4.5S13.1 15 13.5 18" />
      <path d="M13.2 13.8c.7-.4 1.6-.6 2.5-.6 2 0 3.6 1.2 4 3.4" />
    </svg>
  );
}

export function IconFriends() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="8.5" cy="8" r="2.2" />
      <circle cx="15.5" cy="8" r="2.2" />
      <path d="M4.2 18c.5-2.8 2.2-4.2 4.3-4.2s3.8 1.4 4.3 4.2" />
      <path d="M11.2 18c.5-2.8 2.2-4.2 4.3-4.2s3.8 1.4 4.3 4.2" />
    </svg>
  );
}

export function IconAcquaintance() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="7.5" r="2.3" />
      <path d="M6.5 18.5c.6-3.4 2.8-5.2 5.5-5.2s4.9 1.8 5.5 5.2" />
      <path d="M4 11.5h3.2M16.8 11.5H20" />
    </svg>
  );
}

export function IconCharity() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 20s-6.5-4.2-6.5-9A3.5 3.5 0 0112 8.2 3.5 3.5 0 0118.5 11c0 4.8-6.5 9-6.5 9z" />
      <path d="M9.2 11.2h5.6" />
    </svg>
  );
}
